import React, {useEffect} from 'react';
import {Form, Card, Button, Row, Col} from 'react-bootstrap';
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {actions} from "../../../../redux/modules/auth/actions";
import {editMyInfo} from "../../../../redux/modules/auth/crud";
import {BANKS, getLabel} from "../../../../utils/codes";
import * as Yup from "yup";
import {useFormik} from "formik";
import {makeHasError, makeValidClasses} from "../../../../utils/formHelpers";

const validationSchema = Yup.object().shape({
  password: Yup.string().required("비밀번호를 입력하세요.").min(8, "8자 이상 입력하세요.").max(50, "50자 이하로 입력하세요."),
  passwordConfirm: Yup.string().required("비밀번호를 한번 더 입력하세요.").when("password", {
    is: (val) => (val && val.length > 0 ? true : false),
    then: Yup.string().oneOf([Yup.ref("password")], "입력한 비밀번호와 일치하지 않습니다."),
  }),
  email: Yup.string().email('올바른 형식의 이메일을 입력해주세요.').required("이메일 주소를 입력하세요."),
});

export function UserForm(props) {
  const dispatch = useDispatch();

  const user = useSelector(
    (state) => state.auth.user,
    shallowEqual
  );

  const form = useFormik({
    initialValues: {
      password: "",
      passwordConfirm: "",
      email: user.email,
    },
    validationSchema,
    onSubmit: (values, {setStatus, setSubmitting, ...etc}) => {
      const {password, email} = values;
      editMyInfo({password, email})
        .then(() => {
          alert('수정 되었습니다.');
          dispatch(actions.editMyInfo({password, email}));
        })
        .catch(err => {
          alert(err.message);
        })
    },
  });

  const getValidClasses = makeValidClasses(form);
  const hasError = makeHasError(form);

  useEffect(() => {
    if (!user) {
      dispatch(actions.requestUser());
    }
  //eslint-disable-next-line
  }, []);

  return (
    <Form onSubmit={form.handleSubmit}>
      {/* 룰루 기본 정보 */}
      <p className="font-weight-boldest text-primary mb-3">
        룰루 기본 정보
      </p>

      <Form.Group as={Row} className="mb-3">
        <Form.Label column sm={3}>ID</Form.Label>
        <Col sm={9}>
          <Form.Control disabled value={user.adminId}/>
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3">
        <Form.Label column sm={3}>비밀번호</Form.Label>
        <Col sm={9}>
          <Form.Control
            type="password"
            value={form.values.password}
            name="password"
            className={`${getValidClasses("password")}`}
            {...form.getFieldProps("password")}
          />
          {hasError('password') && (
            <div className="fv-plugins-message-container">
              <Form.Text className="fv-help-block">{form.errors.password}</Form.Text>
            </div>
          )}
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3">
        <Form.Label column sm={3}>비밀번호 확인</Form.Label>
        <Col sm={9}>
          <Form.Control
            type="password"
            value={form.values.passwordConfirm}
            name="passwordConfirm"
            className={`${getValidClasses("passwordConfirm")}`}
            {...form.getFieldProps("passwordConfirm")}
          />
          {hasError('passwordConfirm') && (
            <div className="fv-plugins-message-container">
              <Form.Text className="fv-help-block">{form.errors.passwordConfirm}</Form.Text>
            </div>
          )}
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3">
        <Form.Label column sm={3}>전화번호</Form.Label>
        <Col sm={9}>
          <Form.Control disabled value={user.telNo}/>
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3">
        <Form.Label column sm={3}>e-mail</Form.Label>
        <Col sm={9}>
          <Form.Control
            type="email"
            className={`${getValidClasses("email")}`}
            {...form.getFieldProps("email")}
          />
          {hasError('email') ? (
            <div className="fv-plugins-message-container">
              <Form.Text className="fv-help-block">{form.errors.email}</Form.Text>
            </div>
          ) : null}
        </Col>
      </Form.Group>


      {/* 정산 정보 */}
      <p className="font-weight-boldest text-primary mb-3 mt-10">
        정산 정보
      </p>

      <Form.Group as={Row} className="mb-3">
        <Form.Label column sm={3}>입금계좌</Form.Label>
        <Col sm={9}>
          <Form.Control
            disabled
            value={`${getLabel(BANKS, user.bankCd)} / ${user.dpstStkNm} / ${user.accNum}`}
          />
        </Col>
      </Form.Group>

      <Card.Footer className="px-0 text-right pb-0">
        <Button
          type="submit"
          variant="primary"
          disabled={!form.isValid}
        >
          저장
        </Button>
      </Card.Footer>
    </Form>
  )

}
